import { createTheme } from '@mui/material/styles';

// TO GET THE RELEVANT COLOR SHADES - https://www.color-hex.com/
export const COLOR = {
    PURPLE: '#4C43A3', // Primary color
    LIGHT_PURPLE: '#6A677E', // Secondary color
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    RED: '#EF4343', // Danger color
    GRAYISH_BLUE: '#E1E8ED', // Divider, grid line, soft background
    MINT_GREEN: '#D4F8E8', // Success/confirmation states
    WARM_PINK: '#FDE2E4', // Error/alert states
    WARM_YELLOW: '#FFF7CC', // Warning messages
    GREY: '#707070',

    // DISABLED
    DISABLED: { PURPLE: '#4C43A366' },
};

export const MuiTheme = createTheme({
    palette: {
        primary: { main: COLOR.PURPLE, contrastText: COLOR.WHITE },
        secondary: { main: COLOR.LIGHT_PURPLE },
        text: { primary: COLOR.BLACK, secondary: COLOR.WHITE },
        background: { paper: COLOR.WHITE },
        success: { main: COLOR.MINT_GREEN },
        error: { main: COLOR.RED },
        // warning: { main: COLOR.WARM_YELLOW },
    },
    typography: {
        fontFamily: "'Open Sans', sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: 14,
                    textTransform: 'none',
                    lineHeight: 2,
                    boxShadow: 'none',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'rgba(0, 0, 0, 0.6)',
                    '&.Mui-error': {
                        color: COLOR.RED,
                    },
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    '& p': {
                        marginBottom: 0,
                    },
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: { border: 'none' },
                columnHeaders: {
                    backgroundColor: COLOR.WHITE,
                    fontWeight: 600,
                    color: COLOR.LIGHT_PURPLE,
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                },
                cell: {
                    borderBottom: `1px solid ${COLOR.GRAYISH_BLUE}`,
                    fontSize: 14,
                    color: COLOR.LIGHT_PURPLE,
                },
                footerContainer: {
                    paddingTop: '6px',
                },
                footerContainerText: {
                    marginBottom: 0,
                },
                tablePaginationRoot: {
                    overflow: 'hidden',
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    color: COLOR.LIGHT_PURPLE,
                    '&.MuiChip-colorError.MuiChip-root': {
                        backgroundColor: COLOR.WARM_PINK,
                    },
                    '&.MuiChip-colorWarning.MuiChip-root': {
                        backgroundColor: COLOR.WARM_YELLOW,
                    },
                },
                icon: {
                    fontSize: '16px',
                    color: COLOR.LIGHT_PURPLE,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    color: COLOR.BLACK,
                    '&.Mui-error': {
                        color: COLOR.RED,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: COLOR.RED,
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    padding: '12px 24px',
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: COLOR.GREY,
                    '&.Mui-checked': {
                        color: COLOR.PURPLE,
                    },
                },
            },
        },
    },
});
